










import UnderConstruction from "@/components/UnderConstruction.vue"
import { Vue, Component } from "vue-property-decorator"

@Component({
  name: "Deployment",
  components: {
    "under-construction": UnderConstruction,
  },
})
export default class Deployment extends Vue {}
